export const socialsData = {
  github: "https://github.com/venkycoder422",
  // facebook: 'https://www.facebook.com/',
  linkedIn: "https://www.linkedin.com/in/venkatesulu-webdeveloper/",
  // instagram: 'https://www.instagram.com/',
  // codepen: 'https://codepen.io/',
  // twitter: 'https://twitter.com/',
  // reddit: 'https://www.reddit.com/user/',
   blogger: 'https://thoughts-venky.blogspot.com/',
  //medium: "https://medium.com/",
  // stackOverflow: 'https://stackoverflow.com/users/',
  // gitlab: 'https://gitlab.com/',
  // youtube: 'https://youtube.com/'
};
